import axios from 'axios';

const API = axios.create({
  baseURL: 'https://jirani-backend-production.up.railway.app/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// ── Attach token to every request automatically ──────────
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('jirani_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ── Handle global errors ─────────────────────────────────
API.interceptors.response.use(
  (response) => response,
  (error) => {
    const status  = error.response?.status;
    const message = error.response?.data?.message || 'Something went wrong.';

    if (status === 401) {
      localStorage.removeItem('jirani_token');
      window.location.href = '/login';
    }

    return Promise.reject({ status, message });
  }
);

export default API;